<template>
    <div class="inner-file">
        <label :style="{width: width, cursor: pointer}" class="label-input" for="file-input">{{ fileName }}
            <input style="{cursor: pointer}" type="file" id="file-input" class="input-file" v-on:change="fileChanged($event)" v-if="!readonly">
        </label>
        <a href="javascript:" class="btn-d" v-if="!!getFile()" @click.prevent="downloadFile(getFile())"><i class="fa fa-download"></i></a>
        <a href="javascript:" v-if="!!getFile() && !readonly" class="btn" title="Удалить" @click="$emit('deleteFile')"><i
            class="fa fa-times"></i></a>
    </div>
</template>

<script>
import FileAPI from "../../modules/file/api";
import Constants from "../constants";

export default {
    name: "FileUpload",
    props: {
        label: {
            type: String,
            default: "Выберите файл"
        },
        width: String,
        entity: Object,
        propName: String,
        entityIndex: Number,
        readonly: Boolean
    },
    emits: ['uploaded'],
    methods: {

        getFile() {
            return this.entity[this.propName];
        },
        downloadFile(file) {
            FileAPI.download(file.id)
                .then(response => {
                    const blob = new Blob([response.data], {type: file.fileType});
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = file.originalName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                });
        },

        fileChanged(e) {
            const file = e.target.files[0];
            FileAPI.upload(file)
                .then((response) => {
                    this.$emit('uploaded', {
                        entityIndex: this.entityIndex,
                        propName: this.propName,
                        data: response.data
                    });
                }).catch(() => {
                Constants.alert.fire('Ошибка', 'Не удалось загрузить файл.', 'error');
            });
        }
    },
    computed: {
        fileName() {
            return this.entity[this.propName] ? this.entity[this.propName].originalName : this.label
        },
    }
}
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
::-webkit-file-upload-button {
    cursor:pointer;
}
input[type=file] {
    cursor:pointer;
}
.input-file {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
    background: $gray-medium;
    border-radius: 6px;
    z-index: 2;
}

label {
    position: relative;
    cursor: pointer;
    font-family: "Roboto", sans-serif;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
    line-height: 140%;
    color: #333333;
    padding: 5px 16px;
    width: 320px;
    height: 40px;
    background: #F5F5FA;
    border-radius: 6px;
    z-index: 3;
}
a:focus{
    box-shadow: none !important;
    outline: none !important;
}
.inner-file {
    min-width: 250px;
    position: relative;
    background: #F5F5FA;
    border-radius: 6px;
    z-index: 1;

    .btn {
        cursor: pointer;
        position: absolute;
        content: "";
        width: 24px;
        height: 24px;
        top: 0;
        right: 24px;
        z-index: 99;
    }
    .btn-d{
        cursor: pointer;
        position: absolute;
        content: "";
        width: 24px;
        height: 24px;
        top: 50%;
        right: 48px;
        z-index: 99;
        transform: translateY(-55%);
    }
}

.fa-times {
    color: $red-dark;
}
.fa-download{
    color: $blue-light
}
</style>